import React from "react";
//sayani Changes new file
const FilterItemSelectedTick = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.72514 10.3914C3.96922 10.1473 4.36495 10.1473 4.60903 10.3914L7.50042 13.2828L15.3918 5.39137C15.6359 5.14729 16.0316 5.14729 16.2757 5.39137C16.5198 5.63545 16.5198 6.03118 16.2757 6.27526L7.94236 14.6086C7.69828 14.8527 7.30256 14.8527 7.05848 14.6086L3.72514 11.2753C3.48107 11.0312 3.48107 10.6354 3.72514 10.3914Z"
        fill="#A4A3B1"
      />
    </svg>
  );
};

export default FilterItemSelectedTick;
